import { getUrlViewFlag } from '@va/dashboard/selectors/core';
import { URL_VIEW } from '@va/types/website';
import { fontWeights, ParagraphWithTooltip } from '@va/ui/design-system';
import { useSelector } from 'react-redux';
import { InteractivePageUrl } from './InteractivePageUrl';

type InteractivePageUrlCellProps = { pageUrl: string; pageTitle?: string; isExternal?: boolean; color?: string };

export const InteractivePageUrlCell = ({ pageUrl, pageTitle, isExternal, color }: InteractivePageUrlCellProps) => {
  const urlViewFlag = useSelector(getUrlViewFlag);

  return (
    <div className='w-full h-full text-left flex flex-col justify-center overflow-hidden'>
      <div className='flex items-center gap-1'>
        {color && (
          <div
            style={{ backgroundColor: color }}
            className='shrink-0 rounded-full w-3 h-3 border border-white -left-1 top-0'
          />
        )}
        {pageTitle && urlViewFlag === URL_VIEW.title ? (
          <ParagraphWithTooltip colorClassName='text-gray-charcoal' weight={fontWeights.medium} className='text-left'>
            {pageTitle}
          </ParagraphWithTooltip>
        ) : (
          <InteractivePageUrl
            isExternal={isExternal}
            pageUrl={pageUrl || '/'}
            className='text-gray-charcoal! text-15'
          />
        )}
      </div>
      {pageTitle && urlViewFlag === URL_VIEW.title ? (
        <InteractivePageUrl isExternal={isExternal} pageUrl={pageUrl || '/'} />
      ) : null}
    </div>
  );
};
